import React, { useEffect, useState } from 'react';
import { TickSvg } from 'AppSrc/core/components/common/svg-icons';
// import { VFDropdownBase } from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown-base';
import {
  setRelatedCoordinatorID,
  // clearRelatedCoordinatorID,
} from 'AppSrc/core/actions/actions-edit-form';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import PropTypes from 'prop-types';
import { getCoordinatorGroupMembers } from 'AppSrc/core/coordinators/coordinator-queries';
import 'AppSrc/core/style/components/view-crq-screen/change-assignee-modal.css';
import { useDispatch, useSelector } from 'react-redux';

const RelatedCoordinatorTableVine = React.memo(({
  isCreateRelated,
}) => {
  const [displayMembers, setDisplayMembers] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [groupMembers, setGroupMembers] = useState([]);
  const [selectedMember, setSelectedMember] = useState('');
  const [fetching, setFetching] = useState(false);
  const dispatch = useDispatch();
  const getExistingRelatedCoordinatorId = useSelector(((state) => state.remedyReferenceCrq.crqData.coordinator));

  useEffect(() => {
    // get coordinator group members from group id mobile 'Fixed line'
    const fixedLineGroupID = 'SGP000000024650';
    if (isCreateRelated === 'Yes') {
      setFetching(true);
      const network = 'mobile';
      getCoordinatorGroupMembers(network, fixedLineGroupID).then((results) => {
        // DISPATCH HERE FREYJA
        const hasRelCoordinator = getExistingRelatedCoordinatorId ? getExistingRelatedCoordinatorId : 'mv8';
        setSelectedMember(hasRelCoordinator);
        dispatch(setRelatedCoordinatorID(hasRelCoordinator));
        setGroupMembers([...results]);
        setDisplayMembers([...results]);
        setFetching(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCreateRelated, getExistingRelatedCoordinatorId]);

  // const onClickOpenIndividualModel = () => {
  //   getApproverGroups('mobile').then((result) => {
  //     setGroupMap([...result]);
  //   });
  // };


  const setApprovarEmailHandle = (param) => {
    setSelectedMember(param.id);
    dispatch(setRelatedCoordinatorID(param.id));
  };

  const searchHandler = (event) => {
    // Search function for filter array by searching any related text keywords
    const searchQuery = event.toLowerCase();
    const displayedName = groupMembers.filter((el) => {
      const searchValue = el.full_name.toLowerCase().includes(searchQuery);
      return searchValue;
    });

    setDisplayMembers(displayedName);
    setSearchInput(event);
  };


  return (
    <>
      {
        fetching
          ? <h3>Loading...</h3> : (
            <div className="outer-individual-wrap">
              <div className="change-assignee-vine">
                <div className="change-assignee-shadow" />
                <div className="change-assignee-inner">
                  <div className="drop-down-group ind-wrap">
                    <h3>Select Coordinator For Related Ticket</h3>
                    {/* <VFDropdownBase
                displayOptions={displayOptionss}
                updateValue={(value) => {
                  // get the group with the correct id out and pass it to setGroup
                  const group = groupMap.find((item) => item.id === value);
                  setUpdateData(group);
                }}
                fieldTitle="Select Individual Sponsor From Any Group"
                placeholder="Select Groups"
                name="selectGroup"
                value={selectedGroupId}
              // touched={touched}
              // inlineErrors={inlineErrors}
              /> */}
                    { // Show selected members from redux store
                      selectedMember && (
                        <div className="display-selected-user">
                          <h4>
                            {'Selected Coordinator - '}
                            {selectedMember}
                          </h4>
                        </div>
                      )
                    }
                  </div>
                  {groupMembers.length > 0 && (
                    <div className="ressign-table-outer select-assignee-section select-assignee-section-change-coordinator">
                      <h3 className="section-title">Fixed Line Group Members</h3>
                      <div className="select-coordinator-table vf-table">
                        <div className="vf-table-head-container">
                          <div className="vf-table-head">
                            <div className="head-item">
                              <span className="head-text">
                                Name
                              </span>
                            </div>
                            <div className="head-item">
                              <span className="head-text">
                                ID
                              </span>
                            </div>
                          </div>
                        </div>
                        <>
                          { // Search div when default array length > 2
                            groupMembers.length > 2 && (
                              <div className="search-drop">
                                <input
                                  className="Search-Input"
                                  type="text"
                                  onChange={(e) => searchHandler(e.target.value)}
                                  placeholder=" Please Search Here..."
                                  value={searchInput}
                                />
                                <div className={`no-result-msg ${displayMembers.length === 0 ? 'show-no-result' : 'hide-no-result'}`}><p>No Search Result Found</p></div>
                              </div>
                            )
                          }
                        </>
                        <div className="vf-table-body">
                          {
                            displayMembers.map((member) => {
                              const isSelected = member.id === selectedMember;
                              return (
                                <div
                                  className={`vf-table-row-container${isSelected ? ' selected' : ''}`}
                                  key={member.id}
                                >
                                  <div className="vf-table-row">
                                    <OptionButton
                                      className="row-button"
                                      onClick={setApprovarEmailHandle}
                                      option={member}
                                    // disabled={isSelected}
                                    >
                                      <div className="row-item">
                                        <span className="row-item-text">
                                          {member.full_name}
                                        </span>
                                      </div>
                                      <div className="row-item member-selected">
                                        <span className="row-item-text">
                                          {member.id}
                                        </span>
                                        {((selectedMember === member.id) === true) && (
                                          <div className="svg-wrapper">
                                            <TickSvg />
                                          </div>
                                        )}
                                      </div>
                                    </OptionButton>
                                  </div>
                                </div>
                              );
                            })
                          }
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )
        }
    </>
  );
});

RelatedCoordinatorTableVine.propTypes = {
// The value of display options can take on a variety of shapes here
  isCreateRelated: PropTypes.string,
};

export { RelatedCoordinatorTableVine };
